import 'angular:locale/data:de';
import 'angular:locale/data:pt';
import 'angular:locale/data:zh';
import 'angular:locale/data:es';
import 'angular:locale/data:ca';
import 'angular:locale/data:en-US';
import 'angular:locale/data:fr';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
